module.exports = __webpack_public_path__ + "img/dollar.d7d5d4f9.svg";